import React from "react";
import PropTypes from "prop-types";

import { contentTypes } from "core/props";

import PhotoDetails from "./PhotoDetails";
import IconDetails from "./IconDetails";
import { SecondaryText, Divider, PublicDomainMessageSection } from "./styles";

const AttributionPublic = ({ type }) => {
    return (
        <>
            <Divider />
            <PublicDomainMessageSection>
                {type === "photo" ? <PhotoDetails /> : <IconDetails />}
                <SecondaryText size={12}>
                    No need to attribute artist (but it’s nice to do!)
                </SecondaryText>
            </PublicDomainMessageSection>
        </>
    );
};

AttributionPublic.propTypes = {
    type: PropTypes.oneOf(contentTypes)
};

export default AttributionPublic;
